

export const StatusSpace = [
  { id: 1, text: "Disponible" },
  { id: 2, text: "Apartado" },
  { id: 3, text: "Rentado" },
]